import { render } from "./FlowerType.vue?vue&type=template&id=1927076a"
import script from "./FlowerType.vue?vue&type=script&lang=js"
export * from "./FlowerType.vue?vue&type=script&lang=js"

import "./FlowerType.vue?vue&type=style&index=0&id=1927076a&lang=scss"

import exportComponent from "/home/ubuntu/jalizan/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__